import { render, staticRenderFns } from "./RequestContextMenu.vue?vue&type=template&id=7a357ed3&scoped=true&"
import script from "./RequestContextMenu.vue?vue&type=script&lang=js&"
export * from "./RequestContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./RequestContextMenu.vue?vue&type=style&index=0&id=7a357ed3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a357ed3",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/RequestTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fcbs-request%2FRequestContextMenu.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports